import React from 'react';
import {injectIntl} from 'react-intl';

const NotFound = ({intl, staticContext}) => {
  if (staticContext) {
    staticContext.status = 404;
  }
  return (
    <div>
      <div className="block__wrapper wrapper">
        <h2 className="block__title">{intl.formatMessage({id: 'Page.NotFound'})}</h2>
      </div>
    </div>
  );
};

export default injectIntl(NotFound);
